import React from 'react';
import '../../../styles/TripGuarantee.css';
import { TG_URL, TRIP_GUARANTEE, TG_TEXT_LINK, TG_TEXT, WAITLISTED } from './tgConstants';

const TripGuarantee = () => {
  return (
    <a className="tgContainer" href={TG_URL}>
      <div className="tgSubContainer">
        <div className="tgIcon" />
        <div className="tgSubContainerText">
          <div className="tgText">
            {TRIP_GUARANTEE} <span className="tgTextLink">{TG_TEXT_LINK}</span>
          </div>
          <div className="tgSubContainerline">
            Get <span className="tgTextBrown"> {TG_TEXT} </span> {WAITLISTED}
          </div>
        </div>
      </div>
    </a>
  );
};

export default TripGuarantee;
